export default __webpack_public_path__ + "static/media/searchbutton.16d927a7.jpg";